import DapDSTableHeader from './table-header.component'

export * from './table-header.component'
export default DapDSTableHeader

DapDSTableHeader.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-table-header': DapDSTableHeader
  }
}
